import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextInput from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface IProps {
	open: boolean;
	onConfirm: () => void;
	onDismiss: () => void;
	headerText: string;
	body?: React.ReactNode;
	bodyText?: string;
	agreeText: string;
	disagreeText?: string;
	confirmationInput?: string;
}

function ConfirmDialog({
	open,
	onConfirm,
	onDismiss,
	headerText,
	body,
	bodyText,
	agreeText,
	disagreeText,
	confirmationInput,
}: IProps) {
	const { t } = useTranslation();
	const [confirmationFieldValue, setConfirmationFieldValue] = useState<string>();

	function dismiss() {
		onDismiss();
		setConfirmationFieldValue("");
	}

	return (
		<Dialog fullScreen={false} open={open} onClose={onDismiss} aria-labelledby="responsive-dialog-title">
			<DialogTitle id="responsive-dialog-title" color="secondary" data-testid="dialogheader">
				{headerText}
			</DialogTitle>
			<DialogContent>
				{body}
				{bodyText && <DialogContentText>{bodyText}</DialogContentText>}
				{confirmationInput && (
					<TextInput
						name="confirmation-input"
						label={t("enterXToConfirm", { confirmationInput })}
						variant="outlined"
						fullWidth
						inputProps={{
							"data-testid": "confirmation-input",
						}}
						onChange={(e) => setConfirmationFieldValue(e.target.value)}
						sx={{ mt: 2 }}
					/>
				)}
			</DialogContent>
			<DialogActions>
				{disagreeText && (
					<Button autoFocus onClick={dismiss} color="primary" data-testid="dismiss-dialog">
						{disagreeText}
					</Button>
				)}
				<Button
					disabled={!!confirmationInput && confirmationFieldValue !== confirmationInput}
					onClick={onConfirm}
					color="primary"
					variant="contained"
					autoFocus
					data-testid="confirm-dialog"
				>
					{agreeText}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmDialog;
